// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__c-PTw","errorLogs":"EditorFooter_errorLogs__1lba4"};